"use client";

import React from "react";
import { House, HeartPulse, UserCheck, Moon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "מטפל סיעודי בבית",
  icon: House,
  path: "/CaregiverServicePagesPage"
}, {
  title: "השגחה בבית חולים",
  icon: HeartPulse,
  path: "/CaregiverServicePagesPage"
}, {
  title: "מטפל סיעודי פרטי",
  icon: UserCheck,
  path: "/CaregiverServicePagesPage"
}, {
  title: "מטפל/ת לילה",
  icon: Moon,
  path: "/CaregiverServicePagesPage"
}];
export default function OurImmediateServices() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="השירותים-המיידיים-שלנו" className="py-24 bg-chart-5/10" dir="rtl">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
            השירותים המיידיים שלנו
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            אנו מספקים מעטפת מלאה של שירותי סיעוד מקצועיים, עם התחייבות לזמינות של עד 5 שעות בכל רחבי הארץ, על ידי מטפלים ישראלים מוסמכים.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto transition-all duration-1000 delay-150 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {servicesData.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} data-index={index}>
                <Link to={service.path} className="block h-full">
                  <Card className="h-full flex flex-col border-none shadow-sm hover:shadow-md transition-shadow duration-300 bg-card">
                    <CardHeader className="pb-4">
                      <div className="size-12 rounded-lg bg-chart-2/10 flex items-center justify-center mb-4 text-chart-2">
                        <Icon className="size-6" strokeWidth={2} />
                      </div>
                      <CardTitle className="text-xl font-default text-foreground">
                        {service.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-grow pb-2">
                      <div className="text-muted-foreground font-default leading-relaxed text-sm md:text-base">
                        {index === 0 && <>
                            שירות סיעודי מקצועי ומסור אצלך בבית בתיווך רפואי מקצועי לדמנציה, שיקום, וטיפול בקשישים עם <Link to="/CaregiverServicePagesPage" className="text-chart-2 hover:underline">מטפל סיעודי ישראלי</Link> מוסמך.
                          </>}
                        {index === 1 && <>
                            השגחה צמודה ומקצועית בתוך בית חולים, במוסדות כמו שיבא, איכילוב ובילינסון, 24 שעות ביממה לשקט הנפשי שלכם. השירות ניתן על ידי <Link to="/CaregiverServicePagesPage" className="text-chart-2 hover:underline">מטפל סיעודי ישראלי</Link> מנוסה בזמינות מיידית.
                          </>}
                        {index === 2 && <>
                            שירותי <Link to="/CaregiverServicePagesPage" className="text-chart-2 hover:underline">מטפל סיעודי ישראלי</Link> פרטי המעניק התאמה למצב רפואי ספציפי ויחס אישי וחם. אנו מספקים פתרון ב-זמינות מיידית לליווי בבית או בבית חולים.
                          </>}
                        {index === 3 && <>
                            השגחה וטיפול מסור במהלך הלילה על ידי <Link to="/CaregiverServicePagesPage" className="text-chart-2 hover:underline">מטפל סיעודי ישראלי</Link> מיומן. השירות כולל השגחה רפואית 24/7 בתיווך מקצועי בבית המטופל או בבית חולים.
                          </>}
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}